module.exports = __webpack_public_path__ + "img/phone.a433889a.svg";